import { withBasePath } from "_config/basePath";

export function invitationEmail(search) {
    const email = new URLSearchParams(search).get("email")?.trim() || "";
    return email.length <= 254 && /^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/.test(email) ? email : "";
}

export function invitationSignupUrl(link) {
    if (typeof link !== "string" || !link) return "";
    try {
        const url = new URL(link, window.location.origin);
        if (url.origin !== window.location.origin || !/^https?:$/.test(url.protocol)) return "";
        // The API returns an app-relative URL, not a deployment-prefixed URL.
        const path = `${url.pathname}${url.search}${url.hash}`;
        return new URL(withBasePath(path), window.location.origin).href;
    } catch { return ""; }
}
